import Moment from "moment-timezone";
import { extendMoment } from "moment-range";
const moment = extendMoment(Moment);

const dateToDutchString = (date) => {
  const _date = moment(date).tz("Europe/Amsterdam").locale("nl");
  return _date.format("dd DD MMM YYYY HH:mm");
};

export default dateToDutchString;



// WEBPACK FOOTER //
// ./src/utils/date-to-dutch-string.js